import { render, staticRenderFns } from "./ProductForm.vue?vue&type=template&id=2e490e93&scoped=true&"
import script from "./ProductForm.vue?vue&type=script&lang=js&"
export * from "./ProductForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProductForm.vue?vue&type=style&index=1&id=2e490e93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e490e93",
  null
  
)

export default component.exports